function filterViewAnimations(animation) {
  var _effect$pseudoElement;

  var effect = animation.effect;
  if (!effect) return false;
  return effect.target === document.documentElement && ((_effect$pseudoElement = effect.pseudoElement) === null || _effect$pseudoElement === void 0 ? void 0 : _effect$pseudoElement.startsWith("::view-transition"));
}

function getViewAnimations() {
  return document.getAnimations().filter(filterViewAnimations);
}

export { getViewAnimations };